import "@nectary/assets/logo/engage-icon";

export const InitialLoader = () => (
  <div
    id="shell-initial-loading" // this should be the same ID is in webpack/index-template.js
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading App"
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }}
  >
    <sinch-logo-engage-icon size={120} />
  </div>
);
